var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleSmallDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23 10H8.99998C8.59998 10 8.29998 10.2 8.09998 10.5C7.89998 10.8 7.99998 11.2 8.19998 11.5L15.2 21.5C15.4 21.8 15.7 21.9 16 21.9C16.3 21.9 16.6 21.7 16.8 21.5L23.8 11.5C24 11.2 24 10.8 23.9 10.5C23.7 10.2 23.4 10 23 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleSmallDown);
export default __webpack_public_path__ + "static/media/triangle-small-down.596fe3d3afa97a41739a46ed286a449e.svg";
export { ForwardRef as ReactComponent };